import React from "react";
import Card from "@albertsons/uds/molecule/Card";
import Button from "@albertsons/uds/molecule/Button";

interface Props {
  selectedDC: string;
  selectedTGTEnvReg: string;
  selectedTGTEnv: string;
  onTGTEnvRegChange: (val: string) => void;
  onTGTEnvChange: (val: string) => void;
  onRunPipeline: () => void;
  onClear: () => void;
  isPublishing: boolean;
  pipelineStatus: string | null;
}

const TargetParams: React.FC<Props> = ({
  selectedDC,
  selectedTGTEnvReg,
  selectedTGTEnv,
  onTGTEnvRegChange,
  onTGTEnvChange,
  onRunPipeline,
  onClear,
  isPublishing,
  pipelineStatus,
}) => {
  const getTargetEnvValue = () => {
    switch (selectedTGTEnvReg) {
      case "VPT":
      return selectedDC;
      case "VPT-U":
      return `${selectedDC}U`;
      case "PreProd":
      return selectedDC;
    }
  };

  return (
    <Card collapsible title="Target Parameters" isOpen={true} className="min-w-[600px] mt15">
      <Card.Content>
        <div className="flex-container">
          <div>MA Target Region</div>
          <div>MA Target Profile</div>
        </div>
        <div className="flex-container">
          <div className="inner-box">
            <select className="dropdown" value={selectedTGTEnvReg} onChange={(e) => onTGTEnvRegChange(e.target.value)}>
              <option value="" disabled>Select option</option>
              <option value="VPT">VPT</option>
              <option value="VPT-U">VPT-U</option>
              <option value="PreProd">PreProd</option>
            </select>
          </div>
          <div className="inner-box">
            <select className="dropdown" value={selectedTGTEnv} onChange={(e) => onTGTEnvChange(e.target.value)}>
              <option value="" disabled>Select option</option>
              {selectedTGTEnvReg && (
                <option key={getTargetEnvValue()} value={getTargetEnvValue()}>
                  {getTargetEnvValue()}
                </option>
              )}
            </select>
          </div>
        </div>

        <div className="flex-container-button right-align">
          <Button
            width={140}
            onClick={onRunPipeline}
            disabled={!selectedDC || !selectedTGTEnv || !selectedTGTEnvReg}
          >
            {isPublishing ? "Publishing..." : "Publish Data"}
          </Button>
          <Button width={140} onClick={onClear}>Clear</Button>
        </div>

        {pipelineStatus && (
          <div
            className={`pipeline-banner ${
              pipelineStatus.includes("Error")
                ? "pipeline-error"
                : pipelineStatus.includes("InProgress")
                ? "pipeline-warning"
                : "pipeline-success"
            }`}
          >
            {pipelineStatus}
          </div>
        )}
      </Card.Content>
    </Card>
  );
};

export default TargetParams;
